<template>  
    <div class="main-page">  

      <!-- 登录信息显示区域 -->
      <div class="user-area">
        <span class="user-info">  
          您好，{{ username }}
          <template v-if="formattedLastLoginTime">上次登录：{{ formattedLastLoginTime }}</template>  
        </span> 
        <span class="modify-password" @click="showPasswordModal = true">修改密码</span>
      </div>
      

      <!-- 密码修改弹窗 -->
      <div v-if="showPasswordModal" class="password-modal-overlay">
        <div class="password-modal">
          <h3>修改密码</h3>

          <form @submit.prevent="handleSubmit">
            <div class="form-group">
              <label>旧密码：</label>
              <input
                :type="isPasswordVisible ? 'text' : 'password'"
                v-model="passwordForm.oldPassword"
                required
                placeholder="请输入旧密码"/>
                <span class="toggle-eye" @click="togglePasswordVisibility">  
            
                </span>
            </div>

            <div class="form-group">
              <label>新密码：</label>
              <input
                :type="isPasswordVisible ? 'text' : 'password'"
                v-model="passwordForm.newPassword"
                required
                placeholder="密码包含大/小写字母和数字且至少8位"
                minlength="8"/>
                <span class="toggle-eye" @click="togglePasswordVisibility">  
            
                </span>
            </div>

            <div class="form-group">
              <label>确认密码：</label>
              <input
                :type="isPasswordVisible ? 'text' : 'password'"
                v-model="passwordForm.confirmPassword"
                required
                placeholder="再次输入新密码"
                :class="{ 'error': !isPasswordMatch }"/>
              <span class="toggle-eye" @click="togglePasswordVisibility">  
            
              </span>
          </div>

          <div class="button-group">
            <button type="button" @click="handleCancel">取消</button>
            <button type="submit" :disabled="isSubmitting">
              {{ isSubmitting ? '提交中...' : '确定' }}
            </button>
          </div>

          </form>
        </div>
      </div> 
      
      <header class="header">  
        <nav class="nav-links">  
          <button class="nav-button" @click="currentModule = 'license'"> 
            <img src="@/assets/icons/licensemanage.svg" alt="授权管理" class="icon" />
            <span class="button-text">软件授权管理</span>
          </button>  
          <button class="nav-button" @click="currentModule = 'licenselog'">
            <img src="@/assets/icons/licensequery.svg" alt="授权日志" class="icon" />
            <span class="button-text">授权日志查询</span>
          </button>   
        </nav>  
      </header>  
  
      <div class="content">  
        <component :is="currentModuleComponent"></component>  
      </div>  
    </div>  
  </template>  
  
  <script>  
  import { ref, computed, getCurrentInstance, defineComponent } from 'vue';
  import { getRelativeLoginTime, parseTableData } from '@/utils/dateFormatter';
  import { logData, summaryData } from '@/utils/publicdata';  // 引入公共数据文件
  import LicenseLog from './LicenseLog.vue';  
  import LicenseManagement from './LicenseManagement.vue';  
  import axios from 'axios';
  
  export default defineComponent ({  
    async created() {
      // 重新加载授权日志信息  
      await this.loadlogdata(this.token);
    },

    setup() {  
        const currentModule = ref('license'); // 默认显示软件授权管理   
        const token = ref('');          // 返回接口使用的令牌   
        const userid = ref('');
        const username = ref('');  
        const lastlogintime = ref('');  
        const { proxy } = getCurrentInstance();  // 获取JSON配置文件

        const showPasswordModal = ref(false);  // 显示密码弹窗
        const isSubmitting = ref(false);       // 提交数据
        const isPasswordVisible = ref(false);  // 控制密码的显隐状态
        const passwordForm = ref ({
          oldPassword: '',
          newPassword: '',
          confirmPassword: ''
        }); 
        const errorMsg = ref('');

        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');  
        token.value = userInfo.token || '';
        userid.value = userInfo.userid || -1;
        username.value = userInfo.username || '';  
        lastlogintime.value = userInfo.lastlogintime || '';  

        const isPasswordMatch = computed(() => {
          return passwordForm.value.newPassword === passwordForm.value.confirmPassword;
        });

        const togglePasswordVisibility = () => {
          isPasswordVisible.value = !isPasswordVisible.value;
        } 

        // 在handleSubmit中添加密码校验
        const isPasswordValid = () => {
          const pwd = passwordForm.value.newPassword;
          return /^(?=.*[a-zA-Z])(?=.*\d)[\w\W]{8,}$/.test(pwd);
        };
        
        // 提交密码修改
        const handleSubmit = async() => {
          if (!passwordForm.value.oldPassword.trim()) {
            alert('旧密码不能为空！');
            return;
          }
          
          if (!isPasswordValid()) {
            alert('密码需包含大/小写字母和数字，至少8位');
            return;
          }
          
          // 前端验证密码输入
          if (!isPasswordMatch.value) {
            alert('两次输入的密码不一致！')
            return;
          }

          try {
            isSubmitting.value = true;
            // 调用修改密码的API接口
            const response = await modifyPassWord(token.value,
                                                  userid.value,
                                                  passwordForm.value);
            if (response.status ===0)
            {
               alert('密码修改成功！');
               handleCancel();
            }
            else {
              errorMsg.value = response.message; // 显示错误信息
              alert(errorMsg.value);
            }
          }
          catch(error){
            alert('修改密码失败：' + error);
          }
          finally {
            isSubmitting.value = false;
          }
        };

        // 修改密码
        const modifyPassWord = async(token, userid, passwordForm) => {
          try {
              // 调用API接口修改用户密码
            const response = await axios.post(proxy.$config.API_BASE_URL + `/rest/modifypassword`, {         
              token,
              userid,
              oldPassword: passwordForm.oldPassword,  // 获取旧密码
              newPassword: passwordForm.newPassword   // 获取新密码
            },
            {
              headers: {  
                'Content-Type': 'application/json'  
              }
            });
            return {  
              status: response.data.status || 0 ,    // 若服务端返回则取服务端的返回状态
              message: response.data.message,
              data: response.data   // 后端返回的数据  
            };  
          } catch (error) {
            let errorMessage = '登录请求失败，请重试！';  // 默认错误消息  

            // 检查 error 对象  
            if (error.response) { // 请求已发出且服务器响应了  
             errorMessage = error.response.data?.message || errorMessage; // 尝试获取后端返回的错误消息  
            }   
            else 
            if (error.request) { // 请求已发出但没有响应  
              errorMessage = '服务器没有响应，请检查您的网络连接。';  
            } 
            else { // 触发了其他错误  
              errorMessage = error.message; // 使用 Axios 返回的原始错误消息  
            }  
            return {  
              status: 1,    // 返回异常时状态标志1
              message: errorMessage   // 返回API调用异常的错误信息 
            };             
          }
        };

        // 取消修改
        const handleCancel = () => {
          showPasswordModal.value = false;
          passwordForm.value = {
            oldPassword: '',
            newPassword: '',
            confirmPassword: ''
          }
        };

        // 使用工具方法格式化登录时间  
        const formattedLastLoginTime = computed(() => {  
          return getRelativeLoginTime(lastlogintime.value);  
        });  
        
        const currentModuleComponent = computed(() => {
          return currentModule.value === 'licenselog' ? LicenseLog : LicenseManagement; 
        });

        // 使用 provide/inject 或全局状态管理  
        // onMounted(async() => {  
      
        // }); 

        const loadlogdata = async(token) => {
          try {   
            // 获取授权日志
            const authlogResponse = await axios.post(proxy.$config.API_BASE_URL + `/rest/querydata`, {
              token,
              querymethod: 'getauthloginfo'
            },
            {
              headers: {  
              'Content-Type': 'application/json'  
              } 
            });

            // 获取日志汇总信息
            const summaryResponse = await axios.post(proxy.$config.API_BASE_URL + `/rest/querydata`, {
              token,
              querymethod: 'getsummaryinfo'
            },
            {
              headers: {  
              'Content-Type': 'application/json'  
              } 
            });

            logData.value = parseTableData(authlogResponse.data);            // 产品信息
            summaryData.value = parseTableData(summaryResponse.data);        // 算法类型

          } catch (error) {  
            alert('加载数据时出错:', error);  
          } 
        };        

      return {  
        currentModule,  
        token,  
        userid,
        username,  
        lastlogintime,  
        formattedLastLoginTime,
        currentModuleComponent,  

        logData,
        summaryData,

        showPasswordModal,
        isSubmitting,
        isPasswordMatch,
        passwordForm,
        isPasswordVisible,
        handleSubmit,
        handleCancel,
        togglePasswordVisibility,
        loadlogdata,
      }; 
    }, 

    components: {  
      LicenseLog,  
      LicenseManagement  
    }   
  });  
  </script>  
  
  <style scoped>  
  .main-page {  
    display: flex;  
    flex-direction: column;  
    font-size: 14px;
  }  
  .header {  
    background-color: #007bff;  
    color: white;  
    padding: 10px;  
    display: flex;  
    flex-direction: column;  
    align-items: center;  
  }  
  .header-title {  
    font-size: 24px;  
    white-space: nowrap; /* 防止折行 */  
  }  

  /* 用户信息区域 */
  .user-area {
    display: flex;
    align-items: baseline;
    gap: 20px;
  }  

  .user-info {
    padding: 10px;
    font-size: 12px;  
    color: #333;  
    text-align: left;  
  }

  .modify-password {
    flex: 1;
    padding: 10px;
    color: #1890ff;
    cursor: pointer;
    transition: opacity 0.3s;
    font-size: 12px;  
    text-align: right;
  }

  .modify-password:hover {
    opacity: 0.8;
  }

  .toggle-eye {  
    position: absolute;  
    right: 10px;  
    top: 50%;  
    transform: translateY(-50%);  
    cursor: pointer;  
    color: #888;  
  } 

/* 遮罩层 */
.password-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* 弹窗主体 */
.password-modal {
  background: white;
  padding: 25px;
  border-radius: 8px;
  width: 400px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
}

.password-modal h3 {
  margin-bottom: 20px;
  color: #333;
  text-align: center;
}

.form-group {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  font-size: 12px;
  gap: 8px;    /* 元素间距 */
}

.form-group label {
  flex: 0 0 80px;    /* 固定宽度 */
  text-align: left;   /* 文字左对齐 */ 
  white-space: nowrap;  /* 防止文字换行 */
  color: #666;
}

.form-group input {
  flex: 1;
  min-width: 200px;    /* 输入框最小宽度 */
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  transition: border-color 0.3s;
  box-sizing: border-box; /* 确保包括内边距和边框在内 */ 
}

.form-group input:focus {
  border-color: #1890ff;
  outline: none;
}

.error {
  border-color: #ff4d4f !important;
}

.error-msg {
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 4px;
  display: block;
}

.button-group {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.button-group button {
  padding: 10px 30px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s;
}

.button-group button[type="submit"] {
  background: #1890ff;
  color: white;
}

.button-group button[type="submit"]:disabled {
  background: #91d5ff;
  cursor: not-allowed;
}

.button-group button[type="button"] {
  background: #f0f0f0;
  color: #666;
}

  .nav-links {  
    display: flex;  
    justify-content: space-around;  
    width: 100%;  
  }  
  .nav-button {  
    padding: 10px;  
    color: white;  
    border: none;  
    background: none;  
    cursor: pointer;  
    display: flex;  
    flex-direction: column; /* 使文本在图标下方 */  
    align-items: center; /* 垂直居中对齐 */  
    transition: background 0.3s;  
  }  
  .nav-button:hover {  
    background-color: rgba(255, 255, 255, 0.2);  
  }  
  .icon {  
  width: 40px; /* 图标宽度 */  
  height: 40px; /* 图标高度 */  
  margin-bottom: 5px; /* 图标与文本之间的间距 */  
  } 
  .button-text {  
  font-size: 12px; /* 文本字体大小 */  
  } 

  /* 卡片控件间距布局 */
  .content {  
    flex-grow: 1;  
    padding: 20px;  
    background-color: #f9f9f9;  
    overflow-y: auto; /* 允许内容滚动 */  
  }  

  .floating-buttons {  
    position: fixed;  
    bottom: 20px;  
    left: 50%;  
    transform: translateX(-50%);  
    display: flex;  
    gap: 10px;  
  }  
  .add-button, .authorize-button {  
    padding: 10px 20px;  
    background-color: #007bff;  
    color: white;  
    border: none;  
    border-radius: 5px;  
    cursor: pointer;  
  }  
  .add-button:hover, .authorize-button:hover {  
    background-color: #0056b3;  
  }  
  </style>